import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastProvider } from "./components/Toasts/ToastContext";
import { AuthProvider } from "./components/Authentication/AuthContext";
import { VisitorProvider } from "./components/extras/VisitorContext";
import { ThemeProvider } from "./components/Theme/ThemeContext";
import { NotificationProvider } from "./components/notifications/NotificationContext";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
    <ThemeProvider>
    <ToastProvider>
      <AuthProvider>
        <NotificationProvider>
        <VisitorProvider>
          <App />
        </VisitorProvider>
        </NotificationProvider>
      </AuthProvider>
    </ToastProvider>
    </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
